import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";

import Profile from "../../assets/img/profile/Raksha.jpg";
import "./About.style.css";

const About = () => {
  return (
    <div id="about">
      <div className="about">
        <h1 className="pt-3 text-center font-details pb-3">ABOUT ME</h1>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            {/* Profile Picture */}
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2 mr-2">
                <Image
                  className="profile justify-content-end"
                  alt="Profile"
                  src={Profile}
                  thumbnail
                  fluid
                />
              </Row>
            </Col>

            {/* Description and links */}
            <Col xs={12} md={6}>
              <Row className="align-items-start p-2 my-details rounded">
                {/* Description */}
                Hi, I'm <strong>&nbsp; Raksha Pawar</strong>
                <br /> A web developer, creative writer, avid reader, and a core
                member of the robotics team of my college, Team Astros.
                <br /> I make Web Apps, and 2D Games for fun and sometimes work
                on random Machine Learning projects to learn.
                <br /> I also have 2 years of experience working with the
                robotics team of my college and competing in an International
                level robotics championship, ABU Robocon.
                <br />I am passionate about learning new technologies and
                finding solutions to problems I face.
                <br />
                <br /> While, I do like to code, I DO NOT sit in front of the
                computer all the time!! So, in my break or in my free time, I am
                either engrossed in a novel or I am busy writing poetry and
                articles for my writing page on Instagram.
                <br /> I also love to travel and explore new places and since I
                am also a foodie, I love to try new cuisines which are native to
                the places I visit.
                <br />
                <br />
                Oh! and also, I am a Computer Engineering student and will be
                graduating from my college in 2021.
                <br />
                <br />
                {/* Links */}
                <Col className="d-flex justify-content-center flex-wrap">
                  <div>
                    <a href="#contact">
                      <Button className="m-2" variant="outline-primary">
                        Wanna Talk?
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://docs.google.com/document/d/1iA-SDwcT8J0KgfywG6x2RQCfaZq01kTGa7yL9qFuulM/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="m-2" variant="outline-success">
                        My Resume
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/RakshaPawar108"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="m-2" variant="outline-dark">
                        GitHub
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.linkedin.com/in/rakshapawar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="m-2" variant="outline-info">
                        LinkedIn
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
